<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-list-item-title style="white-space: normal !important;">
                {{ reply.field_textarea.value }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldTextareaReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
    }
</script>

<style scoped>

</style>